<template>
  <div>
    <div class="main-wrapper">
      <layout-header></layout-header>

      <layout-navbar></layout-navbar>

      <!-- Page Wrapper -->

      <div class="page-wrapper">
        <!-- Page Content -->

        <div class="content container-fluid" style="background-color: #f6f6f6">
          
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 md12 lg12>
                    <v-carousel
                      style="background-color: #ffffff; height: 200px"
                      height="300"
                      cycle
                      hide-delimiter-background
                      show-arrows-on-hover
                      dark
                    >
                      <v-carousel-item
                        v-for="slide in companyimg"
                        :key="slide.index"
                        :src="barImg"
                        style="border-radius:5px; 5px 5px 5px 5px"
                      >
                        <v-row class="fill-height" align="center">
                          <!-- <v-col cols="12">
                            <div
                              style="
                                color: var(--W, #fff);
                                text-align: center;
                                leading-trim: both;

                                text-edge: cap;
                                font-family: Roboto;
                                font-size: 14px;
                                font-style: normal;
                                font-weight: 400;
                                line-height: 20px; /* 142.857% */
                                letter-spacing: -0.28px;
                              "
                            >
                              <h3>
                                <b>{{ slide.name }}</b>
                              </h3>
                            </div>
                          </v-col> -->

                          <v-col cols="12">
                            <div
                              style="
                                color: var(--W, #fff);
                                text-align: center;
                                leading-trim: both;

                                text-edge: cap;
                                font-family: Roboto;
                                font-size: 14px;
                                font-style: normal;
                                font-weight: 400;
                                line-height: 20px; /* 142.857% */
                                letter-spacing: -0.28px;
                              "
                            >
                              {{ slide.remarks }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-carousel-item>
                    </v-carousel>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md6 lg6>
                    <v-card
                      style="
                        height: 300px;
                        flex-shrink: 0;
                        fill: #fff;
                        stroke-width: 0.5px;
                        stroke: #dfdfdf;
                      "
                    >
                      <v-card-title
                        style="
                          color: var(--B, #171523);
                          leading-trim: both;
                          text-edge: cap;
                          font-family: Roboto;
                          font-size: 16px;
                          font-style: normal;
                          font-weight: 400;
                          line-height: 48px; /* 300% */
                          letter-spacing: -0.32px;
                        "
                      >
                        Expired Documents 📄  <div
                          style="
                            color: var(--B, #171523);
                            leading-trim: both;
                            text-edge: cap;
                            font-family: Roboto;
                            font-size: 16px;
                            font-style: normal;
                            font-weight: 600;
                            line-height: 48px;
                            letter-spacing: -0.32px;
                          "
                        >({{ Expirys.length }})</div><v-spacer></v-spacer>
                        <div class="text-center">
                          <v-icon color="red">mdi-folder-alert</v-icon>
                        </div>
                      </v-card-title>
                      <v-card-text class="text-center">
                        <div>
                          <img
                            :src="docx"
                            style="width: 230px; height: 150px"
                            v-if="Expirys.length === 0"
                          />
                          <div
                            style="
                              color: var(--B, #171523);
                              text-align: center;
                              leading-trim: both;
                              text-edge: cap;
                              font-family: Roboto;
                              font-size: 12px;
                              font-style: normal;
                              font-weight: 400;
                              line-height: 48px; /* 400% */
                            "
                                v-if="Expirys.length === 0"
                          >
                            No doc expired in 30 days found
                          </div>
                          <v-simple-table
                            height="200"
                            v-if="Expirys.length > 0"
                          >
                            <tbody>
                              <tr
                                v-for="(item, index) in Expirys"
                                :key="item.index"
                              >
                                <td style="width: 3px" class="text-right">
                                  <v-icon color="primary" size="35"
                                    >mdi-file-document-multiple</v-icon
                                  >
                                </td>
                                <td class="text-left">
                                  <div
                                    style="
                                      color: var(--B, #171523);
                                      leading-trim: both;
                                      margin-top: 13px;
                                      text-edge: cap;
                                      font-family: Roboto;
                                      font-size: 14px;
                                      font-style: normal;
                                      font-weight: 700;
                                      line-height: 19px; /* 135.714% */
                                      width: 10px;
                                    "
                                  >
                                    {{ titleCase(item.name) }}
                                  </div>

                                  <p
                                    style="
                                      color: #74727b;
                                      leading-trim: both;
                                      text-edge: cap;
                                      font-family: Roboto;
                                      font-size: 10px;
                                      font-style: normal;
                                      font-weight: 500;
                                      line-height: 19px; /* 190% */
                                    "
                                  >
                                    {{ item.documentno }}
                                  </p>
                                </td>
                                <td class="text-right">
                                  <p
                                    style="
                                      color: #74727b;
                                      text-align: right;
                                      leading-trim: both;
                                      text-edge: cap;
                                      font-family: Roboto;
                                      font-size: 14px;
                                      font-style: normal;
                                      font-weight: 400;
                                      line-height: 19px; /* 135.714% */
                                    "
                                  >
                                    {{ item.authority }}
                                  </p>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm6 md6 lg6>
                    <v-card
                      style="
                        height: 300px;
                        flex-shrink: 0;
                        fill: #fff;
                        stroke-width: 0.5px;
                        stroke: #dfdfdf;
                      "
                    >
                      <v-card-title
                        style="
                          color: var(--B, #171523);
                          leading-trim: both;
                          text-edge: cap;
                          font-family: Roboto;
                          font-size: 16px;
                          font-style: normal;
                          font-weight: 400;
                          line-height: 48px; /* 300% */
                          letter-spacing: -0.32px;
                        "
                      >
                        Doc Expiring in 30 Days 📅 <div
                          style="
                            color: var(--B, #171523);
                            leading-trim: both;
                            text-edge: cap;
                            font-family: Roboto;
                            font-size: 16px;
                            font-style: normal;
                            font-weight: 600;
                            line-height: 48px;
                            letter-spacing: -0.32px;
                          "
                        > ({{ Warned.length }})</div>
                      </v-card-title>
                      <v-card-text class="text-center">
                        <div>
                          <img
                            :src="doc1x"
                            style="width: 230px; height: 150px"
                            v-if="Warned.length === 0"
                          />
                          <div
                            style="
                              color: var(--B, #171523);
                              text-align: center;
                              leading-trim: both;
                              text-edge: cap;
                              font-family: Roboto;
                              font-size: 12px;
                              font-style: normal;
                              font-weight: 400;
                              line-height: 48px; /* 400% */
                            "
                                v-if="Warned.length === 0"
                          >
                          No doc expiring in 30 days found
                          </div>
                          <v-simple-table height="200" v-if="Warned.length > 0">
                            <tbody>
                              <tr
                                v-for="(item, index) in Warned"
                                :key="item.index"
                              >
                                <td style="width: 3px" class="text-right">
                                  <v-icon color="primary" size="40"
                                    >mdi-file-document-multiple</v-icon
                                  >
                                </td>
                                <td class="text-left">
                                  <div
                                    style="
                                      color: var(--B, #171523);
                                      leading-trim: both;
                                      margin-top: 13px;
                                      text-edge: cap;
                                      font-family: Roboto;
                                      font-size: 14px;
                                      font-style: normal;
                                      font-weight: 700;
                                      line-height: 19px; /* 135.714% */
                                    "
                                  >
                                    {{ titleCase(item.name) }}
                                  </div>
                                  <p
                                    style="
                                      color: #74727b;
                                      leading-trim: both;
                                      text-edge: cap;
                                      font-family: Roboto;
                                      font-size: 10px;
                                      font-style: normal;
                                      font-weight: 500;
                                      line-height: 19px; /* 190% */
                                    "
                                  >
                                    {{ item.documentno }}
                                  </p>
                                </td>
                                <td class="text-right">
                                  <p
                                    style="
                                      color: #74727b;
                                      text-align: right;
                                      leading-trim: both;
                                      text-edge: cap;
                                      font-family: Roboto;
                                      font-size: 14px;
                                      font-style: normal;
                                      font-weight: 400;
                                      line-height: 19px; /* 135.714% */
                                    "
                                  >
                                    {{ item.authority }}
                                  </p>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 sm4 md4 lg4>
                    <v-card
                      style="
                        height: 300px;
                        flex-shrink: 0;
                        fill: #fff;
                        stroke-width: 0.5px;
                        stroke: #dfdfdf;
                      "
                    >
                      <v-card-title
                        style="
                          color: var(--B, #171523);
                          leading-trim: both;

                          text-edge: cap;
                          font-family: Roboto;
                          font-size: 16px;
                          font-style: normal;
                          font-weight: 400;
                          line-height: 48px; /* 300% */
                          letter-spacing: -0.32px;
                        "
                      >
                        Celebrating Birthdays 🎉  <div
                          style="
                            color: var(--B, #171523);
                            leading-trim: both;
                            text-edge: cap;
                            font-family: Roboto;
                            font-size: 16px;
                            font-style: normal;
                            font-weight: 600;
                            line-height: 48px;
                            letter-spacing: -0.32px;
                          "
                        >({{ birthdaywithimg.length }})</div>
                      </v-card-title>
                      <v-card-text class="text-center">
                        <div>
                          <img
                            :src="doc2x"
                            style="width: 230px; height: 150px"
                            v-if="birthdaywithimg.length === 0"
                          />
                          <div
                            style="
                              color: var(--B, #171523);
                              text-align: center;
                              leading-trim: both;
                              text-edge: cap;
                              font-family: Roboto;
                              font-size: 12px;
                              font-style: normal;
                              font-weight: 400;
                              line-height: 48px; /* 400% */
                            "
                                v-if="birthdaywithimg.length === 0"
                          >
                          No birthday for this month
                          </div>
                        </div>
                        <v-simple-table
                          height="200"
                          v-if="birthdaywithimg.length > 0"
                        >
                          <tbody>
                            <tr
                              v-for="(item, index) in birthdaywithimg"
                              :key="item.index"
                            >
                              <td class="text-right" style="width: 10px">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-avatar
                                      :color="getFallbackColor(item.firstname)"
                                      v-on="on"
                                    >
                                      <img
                                        v-if="isProfileImg(item.img)"
                                        :alt="item.name"
                                        :src="item.img"
                                      />
                                      <div
                                        style="color: #bdc2d8; font-weight: 500"
                                        v-if="isImage(item.img)"
                                      >
                                        {{ item.firstname.substring(0, 1) }}
                                      </div>
                                    </v-avatar>
                                  </template>
                                  <span>{{ titleCase(item.name) }}</span>
                                  <!-- Tooltip content -->
                                </v-tooltip>
                              </td>
                              <td
                                class="text-left"
                                style="
                                  color: var(--B, #171523);
                                  leading-trim: both;
                                  text-edge: cap;
                                  font-family: Roboto;
                                  font-size: 14px;
                                  font-style: normal;
                                  font-weight: 500;
                                  line-height: 35px; /* 135.714% */
                                "
                              >
                                {{ titleCase(item.firstname) }}

                                <p
                                  style="
                                    color: #74727b;
                                    leading-trim: both;
                                    text-edge: cap;
                                    font-family: Roboto;
                                    font-size: 10px;
                                    font-style: normal;
                                    font-weight: 500;
                                    line-height: 19px; /* 190% */
                                  "
                                >
                                  {{ item.month + " " + Math.round(item.day) }}
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm4 md4 lg4>
                    <v-card
                      style="
                        height: 300px;
                        flex-shrink: 0;
                        fill: #fff;
                        stroke-width: 0.5px;
                        stroke: #dfdfdf;
                      "
                    >
                      <v-card-title
                        style="
                          color: var(--B, #171523);
                          leading-trim: both;
                          text-edge: cap;
                          font-family: Roboto;
                          font-size: 16px;
                          font-style: normal;
                          font-weight: 400;
                          line-height: 48px; /* 300% */
                          letter-spacing: -0.32px;
                        "
                      >
                        Work Anniversary 👏  <div
                          style="
                            color: var(--B, #171523);
                            leading-trim: both;
                            text-edge: cap;
                            font-family: Roboto;
                            font-size: 16px;
                            font-style: normal;
                            font-weight: 600;
                            line-height: 48px;
                            letter-spacing: -0.32px;
                          "
                        >({{ workimg.length }})</div>
                      </v-card-title>
                      <v-card-text class="text-center">
                        <div>
                          <img
                            :src="doc3x"
                            style="width: 230px; height: 150px"
                            v-if="workimg.length === 0"
                          />
                        </div>
                        <div
                            style="
                              color: var(--B, #171523);
                              text-align: center;
                              leading-trim: both;
                              text-edge: cap;
                              font-family: Roboto;
                              font-size: 12px;
                              font-style: normal;
                              font-weight: 400;
                              line-height: 48px; /* 400% */
                            "
                                v-if="workimg.length === 0"
                          >
                          No work anniversary for this month
                          </div>
                        <v-simple-table height="200" v-if="workimg.length > 0">
                          <tbody>
                            <tr
                              v-for="(item, index) in workimg"
                              :key="item.index"
                            >
                              <td class="text-right" style="width: 10px">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    &nbsp;&nbsp;&nbsp;
                                    <v-avatar
                                      :color="getFallbackColor(item.firstname)"
                                      v-on="on"
                                    >
                                      <img
                                        v-if="isProfileImg(item.img)"
                                        :alt="item.name"
                                        :src="item.img"
                                      />
                                      <div
                                        style="color: #bdc2d8; font-weight: 500"
                                        v-if="isImage(item.img)"
                                      >
                                        {{ item.firstname.substring(0, 1) }}
                                      </div>
                                    </v-avatar>
                                  </template>
                                  <span>{{ titleCase(item.name) }}</span>
                                  <!-- Tooltip content -->
                                </v-tooltip>
                              </td>
                              <td
                                class="text-left"
                                style="
                                  color: var(--B, #171523);
                                  leading-trim: both;
                                  text-edge: cap;
                                  font-family: Roboto;
                                  font-size: 14px;
                                  font-style: normal;
                                  font-weight: 500;
                                  line-height: 19px; /* 135.714% */
                                  margin-top: 15px;
                                "
                              >
                                {{ titleCase(item.firstname) }}
                              </td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm4 md4 lg4>
                    <v-card
                      style="
                        height: 300px;
                        flex-shrink: 0;
                        fill: #fff;
                        stroke-width: 0.5px;
                        stroke: #dfdfdf;
                      "
                    >
                      <v-card-title
                        style="
                          color: var(--B, #171523);
                          leading-trim: both;

                          text-edge: cap;
                          font-family: Roboto;
                          font-size: 16px;
                          font-style: normal;
                          font-weight: 400;
                          line-height: 48px; /* 300% */
                          letter-spacing: -0.32px;
                        "
                      >
                        Welcome New Join 🙏
                        <div
                          style="
                            color: var(--B, #171523);
                            leading-trim: both;
                            text-edge: cap;
                            font-family: Roboto;
                            font-size: 16px;
                            font-style: normal;
                            font-weight: 600;
                            line-height: 48px;
                            letter-spacing: -0.32px;
                          "
                        >
                          ({{ newjoinwithimg.length }})
                        </div>
                      </v-card-title>
                      <v-card-text class="text-center">
                        <div>
                          <img
                            :src="doc4x"
                            style="width: 230px; height: 150px"
                            v-if="newjoinwithimg.length === 0"
                          />
                        </div>
                        <div
                            style="
                              color: var(--B, #171523);
                              text-align: center;
                              leading-trim: both;
                              text-edge: cap;
                              font-family: Roboto;
                              font-size: 12px;
                              font-style: normal;
                              font-weight: 400;
                              line-height: 48px; /* 400% */
                            "
                                v-if="newjoinwithimg.length === 0"
                          >
                          No one join this month
                          </div>
                        <v-simple-table
                          height="200"
                          v-if="newjoinwithimg.length > 0"
                        >
                          <tbody>
                            <tr
                              v-for="(item, index) in newjoinwithimg"
                              :key="item.index"
                            >
                              <td class="text-right" style="width: 10px">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    &nbsp;&nbsp;&nbsp;
                                    <v-avatar
                                      :color="getFallbackColor(item.firstname)"
                                      v-on="on"
                                    >
                                      <img
                                        v-if="isProfileImg(item.img)"
                                        :alt="item.name"
                                        :src="item.img"
                                      />
                                      <div
                                        style="color: #bdc2d8; font-weight: 500"
                                        v-if="isImage(item.img)"
                                      >
                                        {{ item.firstname.substring(0, 1) }}
                                      </div>
                                    </v-avatar>
                                  </template>
                                  <span>{{ titleCase(item.name) }}</span>
                                  <!-- Tooltip content -->
                                </v-tooltip>
                              </td>
                              <td
                                class="text-left"
                                style="
                                  color: var(--B, #171523);
                                  leading-trim: both;
                                  text-edge: cap;
                                  font-family: Roboto;
                                  font-size: 14px;
                                  font-style: normal;
                                  font-weight: 500;
                                  line-height: 35px; /* 135.714% */
                                "
                              >
                                {{ titleCase(item.firstname) }}
                              </td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
          
        </div>
        <layout-footer></layout-footer>
        <!-- /Page Content -->
      </div>

      <!-- /Page Wrapper -->
    </div>

    <!--theme settings modal-->

    <div
      class="modal right fade settings"
      id="settings"
      role="dialog"
      aria-modal="true"
    >
      <div class="toggle-close">
        <div class="toggle" data-toggle="modal" data-target="#settings">
          <i class="fa fa-cog fa-w-16 fa-spin fa-2x"></i>
        </div>
      </div>

      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header p-3">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>

            <h4 class="modal-title" id="myModalLabel2">Settings</h4>
          </div>

          <div class="modal-body pb-3">
            <div class="scroll">
              <div>
                <ul class="list-group">
                  <li class="list-group-item border-0">
                    <div class="row">
                      <div class="col">
                        <h5 class="pb-2">Primary Skin</h5>
                      </div>

                      <div class="col text-right">
                        <a
                          class="reset text-white bg-dark"
                          id="ChangeprimaryDefault"
                        >
                          Reset Default
                        </a>
                      </div>
                    </div>

                    <div class="theme-settings-swatches">
                      <div class="themes">
                        <div class="themes-body">
                          <ul
                            id="theme-change"
                            class="theme-colors border-0 list-inline-item list-unstyled mb-0"
                          >
                            <li class="theme-title">Solid Color</li>

                            <li class="list-inline-item">
                              <span class="theme-solid-black bg-black"></span>
                            </li>

                            <li class="list-inline-item">
                              <span class="theme-solid-pink bg-primary"></span>
                            </li>

                            <li class="list-inline-item">
                              <span
                                class="theme-solid-orange bg-secondary1"
                              ></span>
                            </li>

                            <li class="list-inline-item">
                              <span
                                class="theme-solid-purple bg-success"
                              ></span>
                            </li>

                            <!-- <li class="list-inline-item"><span class="theme-solid-blue bg-info"></span></li> -->

                            <li class="list-inline-item">
                              <span
                                class="theme-solid-green bg-warnings"
                              ></span>
                            </li>

                            <li><br /></li>

                            <li>
                              <hr />
                            </li>

                            <li class="theme-title">Gradient Color</li>

                            <li class="list-inline-item">
                              <span
                                class="theme-orange bg-sunny-morning"
                              ></span>
                            </li>

                            <li class="list-inline-item">
                              <span class="theme-blue bg-tempting-azure"></span>
                            </li>

                            <li class="list-inline-item">
                              <span class="theme-grey bg-amy-crisp"></span>
                            </li>

                            <li class="list-inline-item">
                              <span class="theme-lgrey bg-mean-fruit"></span>
                            </li>

                            <li class="list-inline-item">
                              <span class="theme-dblue bg-malibu-beach"></span>
                            </li>

                            <li class="list-inline-item">
                              <span class="theme-pink bg-ripe-malin"></span>
                            </li>

                            <li class="list-inline-item">
                              <span class="theme-purple bg-plum-plate"></span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

              <div>
                <ul class="list-group">
                  <li class="list-group-item border-0">
                    <div class="row">
                      <div class="col">
                        <h5 class="pb-2">Header Style</h5>
                      </div>

                      <div class="col text-right">
                        <a
                          class="reset text-white bg-dark"
                          id="ChageheaderDefault"
                        >
                          Reset Default
                        </a>
                      </div>
                    </div>

                    <div class="theme-settings-swatches">
                      <div class="themes">
                        <div class="themes-body">
                          <ul
                            id="theme-change1"
                            class="theme-colors border-0 list-inline-item list-unstyled mb-0"
                          >
                            <li class="theme-title">Solid Color</li>

                            <li class="list-inline-item">
                              <span class="header-solid-black bg-black"></span>
                            </li>

                            <li class="list-inline-item">
                              <span class="header-solid-pink bg-primary"></span>
                            </li>

                            <li class="list-inline-item">
                              <span
                                class="header-solid-orange bg-secondary1"
                              ></span>
                            </li>

                            <li class="list-inline-item">
                              <span
                                class="header-solid-purple bg-success"
                              ></span>
                            </li>

                            <!-- <li class="list-inline-item"><span class="header-solid-blue bg-info"></span></li> -->

                            <li class="list-inline-item">
                              <span
                                class="header-solid-green bg-warnings"
                              ></span>
                            </li>

                            <li><br /></li>

                            <li>
                              <hr />
                            </li>

                            <li class="theme-title">Gradient Color</li>

                            <li class="list-inline-item">
                              <span
                                class="header-gradient-color1 bg-sunny-morning"
                              ></span>
                            </li>

                            <li class="list-inline-item">
                              <span
                                class="header-gradient-color2 bg-tempting-azure"
                              ></span>
                            </li>

                            <li class="list-inline-item">
                              <span
                                class="header-gradient-color3 bg-amy-crisp"
                              ></span>
                            </li>

                            <li class="list-inline-item">
                              <span
                                class="header-gradient-color4 bg-mean-fruit"
                              ></span>
                            </li>

                            <li class="list-inline-item">
                              <span
                                class="header-gradient-color5 bg-malibu-beach"
                              ></span>
                            </li>

                            <li class="list-inline-item">
                              <span
                                class="header-gradient-color6 bg-ripe-malin"
                              ></span>
                            </li>

                            <li class="list-inline-item">
                              <span
                                class="header-gradient-color7 bg-plum-plate"
                              ></span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

              <div>
                <ul class="list-group m-0">
                  <li class="list-group-item border-0">
                    <div class="row">
                      <div class="col">
                        <h5 class="pb-2">Apps Sidebar Style</h5>
                      </div>

                      <div class="col text-right">
                        <a
                          class="reset text-white bg-dark"
                          id="ChagesidebarDefault"
                        >
                          Reset Default
                        </a>
                      </div>
                    </div>

                    <div class="theme-settings-swatches">
                      <div class="themes">
                        <div class="themes-body">
                          <ul
                            id="theme-change2"
                            class="theme-colors border-0 list-inline-item list-unstyled"
                          >
                            <li class="theme-title">Solid Color</li>

                            <li class="list-inline-item">
                              <span class="sidebar-solid-black bg-black"></span>
                            </li>

                            <li class="list-inline-item">
                              <span
                                class="sidebar-solid-pink bg-primary"
                              ></span>
                            </li>

                            <li class="list-inline-item">
                              <span
                                class="sidebar-solid-orange bg-secondary1"
                              ></span>
                            </li>

                            <li class="list-inline-item">
                              <span
                                class="sidebar-solid-purple bg-success"
                              ></span>
                            </li>

                            <!-- <li class="list-inline-item"><span class="sidebar-solid-blue bg-info"></span></li> -->

                            <li class="list-inline-item">
                              <span
                                class="sidebar-solid-green bg-warnings"
                              ></span>
                            </li>

                            <li><br /></li>

                            <li>
                              <hr />
                            </li>

                            <li class="theme-title">Gradient Color</li>

                            <li class="list-inline-item">
                              <span
                                class="sidebar-gradient-color1 bg-sunny-morning"
                              ></span>
                            </li>

                            <li class="list-inline-item">
                              <span
                                class="sidebar-gradient-color2 bg-tempting-azure"
                              ></span>
                            </li>

                            <li class="list-inline-item">
                              <span
                                class="sidebar-gradient-color3 bg-amy-crisp"
                              ></span>
                            </li>

                            <li class="list-inline-item">
                              <span
                                class="sidebar-gradient-color4 bg-mean-fruit"
                              ></span>
                            </li>

                            <li class="list-inline-item">
                              <span
                                class="sidebar-gradient-color5 bg-malibu-beach"
                              ></span>
                            </li>

                            <li class="list-inline-item">
                              <span
                                class="sidebar-gradient-color6 bg-ripe-malin"
                              ></span>
                            </li>

                            <li class="list-inline-item">
                              <span
                                class="sidebar-gradient-color7 bg-plum-plate"
                              ></span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>

                <div class="row Default-font">
                  <div class="col">
                    <h5 class="pb-2">Font Style</h5>
                  </div>

                  <div class="col text-right">
                    <a
                      class="reset text-white bg-dark font-Default"
                      onclick="ChangeFontDefault()"
                    >
                      Reset Default
                    </a>
                  </div>
                </div>

                <ul
                  class="list-inline-item list-unstyled font-family border-0 p-0"
                >
                  <li class="list-inline-item roboto-font">Roboto</li>

                  <li class="list-inline-item poppins-font">Poppins</li>

                  <li class="list-inline-item montserrat-font">Montserrat</li>

                  <li class="list-inline-item inter-font">Inter</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--theme settings-->

    <div class="sidebar-contact">
      <div class="toggle" data-toggle="modal" data-target="#settings">
        <i class="fa fa-cog fa-w-16 fa-spin fa-2x"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { curd, getLogo } from "../service/CallWebService";
const IMG = require("./ImgData");
const BASE_API = require("../service/prod.env");

export default {
  components: {},

  data() {
    return {
      docx: IMG.docx,
      barImg: IMG.barImg,
      doc1x: IMG.doc1x,
      panel: [0, 1, 2],
      doc2x: IMG.doc2x,
      doc3x: IMG.doc3x,
      doc4x: IMG.doc4x,

      iiii: "",

      colorsc: [
        "#3fb1e3",

        "#6be6c1",

        "#a0a7e6",

        "#c4ebad",

        "#96dee8",

        "#3fb1e3",

        "#6be6c1",

        "#a0a7e6",

        "#c4ebad",

        "#96dee8",
      ],

      colorsw: [
        "#c4ebad",

        "#96dee8",

        "#3fb1e3",

        "#6be6c1",

        "#a0a7e6",

        "#c4ebad",

        "#96dee8",

        "#3fb1e3",

        "#6be6c1",

        "#a0a7e6",
      ],

      colorsb: [
        "#a0a7e6",

        "#3fb1e3",

        "#6be6c1",

        "#c4ebad",

        "#96dee8",

        "#a0a7e6",

        "#3fb1e3",

        "#6be6c1",

        "#c4ebad",

        "#96dee8",
      ],

      Expirys: "",

      countc: "",

      countcd: "",

      Warned: "",

      snackbar: false,

      snackbara: false,

      birthday: "",

      works: "",

      newjoining: "",

      img: "",

      birthdaywithimg: [],

      newjoinwithimg: [],

      workimg: [],
      companyimg: [],
    };
  },

  created() {
    this.getESSCompanyAnnouncement();
    this.getESSBirthdayAnnouncement();
    this.getESSWorkAnniversaryAnnouncement();
    this.getNewJoin();
    this.getExpiredDoc();
  },

  methods: {
    isImage(image) {
      if (image === "aa") {
        return true;
      } else {
        return false;
      }
    },

    isProfileImg(image) {
      if (image === "aa") {
        return false;
      } else {
        return true;
      }
    },
    titleCase(str) {
      if (str) {
        var splitStr = str.toLowerCase().split(" ");
        for (var i = 0; i < splitStr.length; i++) {
          // You do not need to check if i is larger than splitStr length, as your for does that for you
          // Assign it back to the array
          splitStr[i] =
            splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        // Directly return the joined string
        return splitStr.join(" ");
      }
    },

    getFallbackColor(firstname) {
      const colors = ["#EFF0F4"];

      const index = firstname.charCodeAt(0) % colors.length;

      return colors[index];
    },

    test() {
      this.snackbar = true;
    },

    leave() {
      this.snackbar = false;
    },

    test1() {
      this.snackbara = true;
    },

    leave1() {
      this.snackbara = false;
    },

    add() {
      localStorage.setItem("doc", JSON.stringify("doc"));
      this.$router.push("/profile");
    },

    getImageNew(id) {
      //new join image
      let img = "";

      const payload = {
        LogoID: id,
      };

      getLogo(payload).then((response) => {
        console.log(response);

        // this.img=response.base64

        console.log("helo", response.base64);

        img = response.base64;

        console.log("testingddddd", this.newjoining);

        for (var i = 0; i < this.newjoining.length; i++) {
          if (this.newjoining[i].logo_id === id) {
            if (img) {
              this.newjoining[i].img = img;
            } else {
              this.newjoining[i].img = "aa";
            }
          }

          if (this.newjoining[i].img) {
            this.newjoinwithimg.push(this.newjoining[i]);
          }

          this.newjoinwithimg = [...new Set(this.newjoinwithimg)];

          this.newjoinwithimg.sort();
        }
      });
    },

    getImage(id) {
      //birthday

      let img = "";

      const payload = {
        LogoID: id,
      };

      getLogo(payload).then((response) => {
        console.log(response);

        // this.img=response.base64

        console.log("enterrrrrrrrrrrrrrrrrrrr", response.base64);

        img = response.base64;

        console.log("testing", JSON.stringify(this.birthday));

        for (var i = 0; i < this.birthday.length; i++) {
          if (this.birthday[i].logo_id === id) {
            if (img) {
              this.birthday[i].img = img;
            } else {
              this.birthday[i].img = "aa";
            }
          }

          if (this.birthday[i].img) {
            this.birthdaywithimg.push(this.birthday[i]);
          }

          this.birthdaywithimg = [...new Set(this.birthdaywithimg)];
          console.log("birthday", this.birthdaywithimg);
          this.birthdaywithimg.sort();
        }
      });
    },

    getCompanyImage(id) {
      //birthday

      let img = "";

      const payload = {
        LogoID: id,
      };

      getLogo(payload).then((response) => {
        console.log(response);

        // this.img=response.base64

        console.log("getCompanyImage", response.base64);

        img = response.base64;
        for (var i = 0; i < this.company.length; i++) {
          if (this.company[i].logo_id === id) {
            if (img) {
              this.company[i].img = img;
            } else {
              this.company[i].img = "aa";
            }
          }

          if (this.company[i].img) {
            this.companyimg.push(this.company[i]);
          }

          this.companyimg = [...new Set(this.companyimg)];
          console.log("getCompanyImageg", this.companyimg);
          this.companyimg.sort();
        }
      });
    },

    getImageWork(id) {
      //work

      let img = "";

      const payload = {
        LogoID: id,
      };

      getLogo(payload).then((response) => {
        console.log(response);

        // this.img=response.base64

        console.log("workers trtr", response);

        img = response.base64;

        console.log("testing", JSON.stringify(this.work));

        for (var i = 0; i < this.works.length; i++) {
          if (this.works[i].logo_id === id) {
            if (img) {
              this.works[i].img = img;
            } else {
              this.works[i].img = "aa";
            }
          }

          if (this.works[i].img) {
            this.workimg.push(this.works[i]);
          }

          this.workimg = [...new Set(this.workimg)];

          this.workimg.sort();

          console.log("final", this.workimg);
        }
      });
    },

    getESSBirthdayAnnouncement() {
      const payload = {
        Method: "getESSBirthdayAnnouncement",

        Input: {
          ad_client_id: Number(
            JSON.parse(localStorage.getItem("AD_Client_ID"))
          ),
        },

        ServiceParameter: { all: "all" },
      };

      curd(payload).then((response) => {
        if (response.message == "Authentication Failed") {
          this.$router.push("/");
        }
        localStorage.setItem("user", JSON.stringify(response.jwt));

        console.log("getESSBirthdayAnnouncement", response);

        if (response.output.length > 0) {
          this.birthday = response.output;

          for (let i = 0; i < this.birthday.length; i++) {
            this.getImage(this.birthday[i].logo_id);
          }
        } else {
          this.birthday = [{ name: "Birthday Greetings" }];
        }
      });
    },

    getESSWorkAnniversaryAnnouncement() {
      const payload = {
        Method: "getESSWorkAnniversaryAnnouncement",

        Input: {
          ad_client_id: Number(
            JSON.parse(localStorage.getItem("AD_Client_ID"))
          ),
        },

        ServiceParameter: { all: "all" },
      };

      curd(payload).then((response) => {
        if (response.message == "Authentication Failed") {
          this.$router.push("/");
        }
        localStorage.setItem("user", JSON.stringify(response.jwt));

        console.log("workers logo", response);

        if (response.output.length > 0) {
          this.works = response.output;

          for (let i = 0; i < this.works.length; i++) {
            this.getImageWork(this.works[i].logo_id);
          }
        } else {
          this.works = [{ name: "company Joinees" }];
        }
      });
    },

    getNewJoin() {
      //newjoin

      const payload = {
        Method: "getJoineeDate",

        Input: {
          ad_client_id: Number(
            JSON.parse(localStorage.getItem("AD_Client_ID"))
          ),
        },

        ServiceParameter: { all: "all" },
      };
      console.log("getJoiningDate ssss", payload);
      curd(payload).then((response) => {
        if (response.message == "Authentication Failed") {
          this.$router.push("/");
        }
        localStorage.setItem("user", JSON.stringify(response.jwt));

        if (response.output.length > 0) {
          this.newjoining = response.output;
          console.log("getJoiningDate ssss", this.newjoining);
          for (let i = 0; i < this.newjoining.length; i++) {
            console.log("oooooooooo", this.newjoining[i].logo_id);
            this.getImageNew(this.newjoining[i].logo_id);
          }
        } else {
          this.newjoining = [{ name: "New Joinees" }];
        }
      });
    },

    getExpiredDoc() {
      const payload = {
        Method: "getWarnedDocument",

        Input: {
          ad_client_id: Number(
            JSON.parse(localStorage.getItem("AD_Client_ID"))
          ),

          HM_Employ_ID: Number(
            JSON.parse(localStorage.getItem("HM_Employ_ID"))
          ),
        },

        ServiceParameter: { all: "all" },
      };

      console.log("getWarnedDocuments", payload);

      curd(payload).then((response) => {
        if (response.message == "Authentication Failed") {
          this.$router.push("/");
        }
        console.log("ExpiredDocumentxx", response);

        localStorage.setItem("user", JSON.stringify(response.jwt));

        let expiredarray = [];

        let expiringarray = [];

        for (let i = 0; i < response.output.length; i++) {
          if (response.output[i].status === "N")
            expiredarray.push(response.output[i]);
          else expiringarray.push(response.output[i]);
        }

        console.log("exxxxxxxxxx", expiredarray);

        this.Expirys = expiredarray;

        this.countc = this.Expirys.length;

        this.Warned = expiringarray;

        this.countcd = this.Warned.length;
      });
    },

    getESSCompanyAnnouncement() {
      const payload = {
        Method: "getESSCompanyAnnouncement",

        Input: {
          ad_client_id: Number(
            JSON.parse(localStorage.getItem("AD_Client_ID"))
          ),
        },

        ServiceParameter: { all: "all" },
      };

      curd(payload).then((response) => {
        if (response.message == "Authentication Failed") {
          this.$router.push("/");
        }
        localStorage.setItem("user", JSON.stringify(response.jwt));

        console.log("getESSCompanyAnnouncement", response);

        if (response.output.length > 0) {
          this.company = response.output;
          for (let i = 0; i < this.company.length; i++) {
            console.log(
              "cccccccccccccccccccccoooooooooo",
              this.company[i].logo_id
            );
            this.getCompanyImage(this.company[i].logo_id);
          }
        } else {
          this.companyimg = [
            {
              name: "Welcome to evitalyst!",

              user: "Teksalah",
              img: "",

              remarks:
                "Welcome to the Employee Self-Service (ESS) Portal, your gateway to easy and convenient access to your personal HR information. From checking your pay stubs and updating your contact details to requesting time off and accessing company policies, the ESS Portal is designed to make your life simpler. With its user-friendly interface, you can manage your HR tasks with just a few clicks. We hope you find the ESS Portal a valuable resource and encourage you to explore all that it has to offer.",
            },
          ];
        }

        console.log("eeeeee", this.company);
      });
    },
  },

  mounted() {
    const user = JSON.parse(localStorage.getItem("user"));

    console.log("aaaaaaaaaaaaaaaaaaaaa", user);

    if (user <= 0) {
      this.$router.push("/");
    }

    $(".roboto-font").click(function () {
      $("body").addClass("roboto");

      $("body").removeClass("inter");

      $("body").removeClass("monstret");

      $("body").removeClass("poppins");
    });

    $(".poppins-font").click(function () {
      $("body").removeClass("roboto");

      $("body").removeClass("inter");

      $("body").removeClass("monstret");

      $("body").addClass("poppins");
    });

    $(".montserrat-font").click(function () {
      $("body").removeClass("roboto");

      $("body").removeClass("inter");

      $("body").addClass("monstret");

      $("body").removeClass("poppins");
    });

    $(".inter-font").click(function () {
      $("body").removeClass("roboto");

      $("body").addClass("inter");

      $("body").removeClass("monstret");

      $("body").removeClass("poppins");
    });

    $(".font-Default").click(function () {
      $("body").removeClass("roboto");

      $("body").addClass("inter");

      $("body").removeClass("monstret");

      $("body").removeClass("poppins");
    });

    /*local storage*/

    !(function ($) {
      "use strict";

      var topNavThemeClass = window.localStorage;
    })(window.jQuery),
      $(function () {
        var headerColors = `theme-default black-mode theme-orange theme-blue theme-grey theme-lgrey theme-dblue theme-pink

    theme-purple theme-solid-pink theme-solid-orange theme-solid-purple theme-solid-blue theme-solid-green

     header-orange header-blue header-grey header-lgrey header-dblue header-pink

    header-purple theme-dark theme-solid-black`;

        $(document).ready(function () {
          var navColor = localStorage.getItem("navbar-color");

          if (navColor) {
            $("body").removeClass(headerColors).addClass(navColor);
          }
        });

        $("#theme-change span").on("click", function () {
          if ($(this).hasClass("theme-default")) {
            $("body").removeClass(headerColors).addClass("theme-default");

            localStorage.setItem("navbar-color", "theme-default");
          }

          if ($(this).hasClass("theme-solid-black")) {
            $("body").removeClass(headerColors).addClass("theme-solid-black");

            localStorage.setItem("navbar-color", "theme-solid-black");
          }

          if ($(this).hasClass("theme-orange")) {
            $("body").removeClass(headerColors).addClass("theme-orange");

            localStorage.setItem("navbar-color", "theme-orange");
          }

          if ($(this).hasClass("theme-dark")) {
            $("body").removeClass(headerColors).addClass("theme-dark");

            localStorage.setItem("navbar-color", "theme-dark");
          }

          if ($(this).hasClass("theme-dark")) {
            $("body").removeClass(headerColors).addClass("theme-dark");

            localStorage.setItem("navbar-color", "theme-dark");
          }

          if ($(this).hasClass("theme-blue")) {
            $("body").removeClass(headerColors).addClass("theme-blue");

            localStorage.setItem("navbar-color", "theme-blue");
          }

          if ($(this).hasClass("theme-grey")) {
            $("body").removeClass(headerColors).addClass("theme-grey");

            localStorage.setItem("navbar-color", "theme-grey");
          }

          if ($(this).hasClass("theme-lgrey")) {
            $("body").removeClass(headerColors).addClass("theme-lgrey");

            localStorage.setItem("navbar-color", "theme-lgrey");
          }

          if ($(this).hasClass("theme-dblue")) {
            $("body").removeClass(headerColors).addClass("theme-dblue");

            localStorage.setItem("navbar-color", "theme-dblue");
          }

          if ($(this).hasClass("theme-pink")) {
            $("body").removeClass(headerColors).addClass("theme-pink");

            localStorage.setItem("navbar-color", "theme-pink");
          }

          if ($(this).hasClass("theme-purple")) {
            $("body").removeClass(headerColors).addClass("theme-purple");

            localStorage.setItem("navbar-color", "theme-purple");
          }

          if ($(this).hasClass("theme-solid-pink")) {
            $("body").removeClass(headerColors).addClass("theme-solid-pink");

            localStorage.setItem("navbar-color", "theme-solid-pink");
          }

          if ($(this).hasClass("theme-solid-orange")) {
            $("body").removeClass(headerColors).addClass("theme-solid-orange");

            localStorage.setItem("navbar-color", "theme-solid-orange");
          }

          if ($(this).hasClass("theme-solid-purple")) {
            $("body").removeClass(headerColors).addClass("theme-solid-purple");

            localStorage.setItem("navbar-color", "theme-solid-purple");
          }

          if ($(this).hasClass("theme-solid-blue")) {
            $("body").removeClass(headerColors).addClass("theme-solid-blue");

            localStorage.setItem("navbar-color", "theme-solid-blue");
          }

          if ($(this).hasClass("theme-solid-green")) {
            $("body").removeClass(headerColors).addClass("theme-solid-green");

            localStorage.setItem("navbar-color", "theme-solid-green");
          }
        });

        $("#ChangeprimaryDefault").on("click", function () {
          $("body").removeClass(headerColors).addClass("theme-default");

          localStorage.setItem("navbar-color", "theme-default");
        });

        $("#ChangedarkDefault").on("click", function () {
          $("body").removeClass(headerColors).addClass("theme-default");

          localStorage.setItem("navbar-color", "theme-default");
        });
      });

    /*local storage*/

    !(function ($) {
      "use strict";

      var topNavThemeClass1 = window.localStorage;
    })(window.jQuery),
      $(function () {
        var headerColors1 = `theme-default black-mode header-solid-pink header-solid-orange header-solid-purple header-solid-blue header-solid-green

    header-gradient-color1  header-gradient-color2 header-gradient-color3 header-gradient-color4 header-gradient-color5 header-gradient-color6

    header-gradient-color7 header-solid-black  `;

        $(document).ready(function () {
          var navColor1 = localStorage.getItem("navbar-color1");

          if (navColor1) {
            $("body").removeClass(headerColors1).addClass(navColor1);
          }
        });

        $("#theme-change1 span").on("click", function () {
          if ($(this).hasClass("theme-default")) {
            $("body").removeClass(headerColors1).addClass("theme-default");

            localStorage.setItem("navbar-color1", "theme-default");
          }

          if ($(this).hasClass("header-solid-black")) {
            $("body").removeClass(headerColors1).addClass("header-solid-black");

            localStorage.setItem("navbar-color1", "header-solid-black");
          }

          if ($(this).hasClass("header-solid-pink")) {
            $("body").removeClass(headerColors1).addClass("header-solid-pink");

            localStorage.setItem("navbar-color1", "header-solid-pink");
          }

          if ($(this).hasClass("header-solid-orange")) {
            $("body")
              .removeClass(headerColors1)
              .addClass("header-solid-orange");

            localStorage.setItem("navbar-color1", "header-solid-orange");
          }

          if ($(this).hasClass("header-solid-purple")) {
            $("body")
              .removeClass(headerColors1)
              .addClass("header-solid-purple");

            localStorage.setItem("navbar-color1", "header-solid-purple");
          }

          if ($(this).hasClass("header-solid-blue")) {
            $("body").removeClass(headerColors1).addClass("header-solid-blue");

            localStorage.setItem("navbar-color1", "header-solid-blue");
          }

          if ($(this).hasClass("header-solid-green")) {
            $("body").removeClass(headerColors1).addClass("header-solid-green");

            localStorage.setItem("navbar-color1", "header-solid-green");
          }

          if ($(this).hasClass("header-gradient-color1")) {
            $("body")
              .removeClass(headerColors1)

              .addClass("header-gradient-color1");

            localStorage.setItem("navbar-color1", "header-gradient-color1");
          }

          if ($(this).hasClass("header-gradient-color2")) {
            $("body")
              .removeClass(headerColors1)

              .addClass("header-gradient-color2");

            localStorage.setItem("navbar-color1", "header-gradient-color2");
          }

          if ($(this).hasClass("header-gradient-color3")) {
            $("body")
              .removeClass(headerColors1)

              .addClass("header-gradient-color3");

            localStorage.setItem("navbar-color1", "header-gradient-color3");
          }

          if ($(this).hasClass("header-gradient-color4")) {
            $("body")
              .removeClass(headerColors1)

              .addClass("header-gradient-color4");

            localStorage.setItem("navbar-color1", "header-gradient-color4");
          }

          if ($(this).hasClass("header-gradient-color5")) {
            $("body")
              .removeClass(headerColors1)

              .addClass("header-gradient-color5");

            localStorage.setItem("navbar-color1", "header-gradient-color5");
          }

          if ($(this).hasClass("header-gradient-color6")) {
            $("body")
              .removeClass(headerColors1)

              .addClass("header-gradient-color6");

            localStorage.setItem("navbar-color1", "header-gradient-color6");
          }

          if ($(this).hasClass("header-gradient-color7")) {
            $("body")
              .removeClass(headerColors1)

              .addClass("header-gradient-color7");

            localStorage.setItem("navbar-color1", "header-gradient-color7");
          }
        });

        $("#ChageheaderDefault").on("click", function () {
          $("body").removeClass(headerColors1).addClass("theme-default");

          localStorage.setItem("navbar-color1", "theme-default");
        });
      });

    /*local storage*/

    !(function ($) {
      "use strict";

      var topNavThemeClass2 = window.localStorage;
    })(window.jQuery),
      $(function () {
        var sidebarColors2 = `theme-default black-mode sidebar-solid-pink sidebar-solid-orange sidebar-solid-purple sidebar-solid-blue sidebar-solid-green

    sidebar-gradient-color1  sidebar-gradient-color2 sidebar-gradient-color3 sidebar-gradient-color4 sidebar-gradient-color5 sidebar-gradient-color6

    sidebar-gradient-color7  sidebar-solid-black`;

        $(document).ready(function () {
          var navColor2 = localStorage.getItem("navbar-color2");

          if (navColor2) {
            $("body").removeClass(sidebarColors2).addClass(navColor2);
          }
        });

        $("#theme-change2 span").on("click", function () {
          if ($(this).hasClass("theme-default")) {
            $("body").removeClass(sidebarColors2).addClass("theme-default");

            localStorage.setItem("navbar-color2", "theme-default");
          }

          if ($(this).hasClass("sidebar-solid-black")) {
            $("body")
              .removeClass(sidebarColors2)

              .addClass("sidebar-solid-black");

            localStorage.setItem("navbar-color2", "sidebar-solid-black");
          }

          if ($(this).hasClass("sidebar-solid-pink")) {
            $("body")
              .removeClass(sidebarColors2)
              .addClass("sidebar-solid-pink");

            localStorage.setItem("navbar-color2", "sidebar-solid-pink");
          }

          if ($(this).hasClass("sidebar-solid-orange")) {
            $("body")
              .removeClass(sidebarColors2)

              .addClass("sidebar-solid-orange");

            localStorage.setItem("navbar-color2", "sidebar-solid-orange");
          }

          if ($(this).hasClass("sidebar-solid-purple")) {
            $("body")
              .removeClass(sidebarColors2)

              .addClass("sidebar-solid-purple");

            localStorage.setItem("navbar-color2", "sidebar-solid-purple");
          }

          if ($(this).hasClass("sidebar-solid-blue")) {
            $("body")
              .removeClass(sidebarColors2)
              .addClass("sidebar-solid-blue");

            localStorage.setItem("navbar-color2", "sidebar-solid-blue");
          }

          if ($(this).hasClass("sidebar-solid-green")) {
            $("body")
              .removeClass(sidebarColors2)

              .addClass("sidebar-solid-green");

            localStorage.setItem("navbar-color2", "sidebar-solid-green");
          }

          if ($(this).hasClass("sidebar-gradient-color1")) {
            $("body")
              .removeClass(sidebarColors2)

              .addClass("sidebar-gradient-color1");

            localStorage.setItem("navbar-color2", "sidebar-gradient-color1");
          }

          if ($(this).hasClass("sidebar-gradient-color2")) {
            $("body")
              .removeClass(sidebarColors2)

              .addClass("sidebar-gradient-color2");

            localStorage.setItem("navbar-color2", "sidebar-gradient-color2");
          }

          if ($(this).hasClass("sidebar-gradient-color3")) {
            $("body")
              .removeClass(sidebarColors2)

              .addClass("sidebar-gradient-color3");

            localStorage.setItem("navbar-color2", "sidebar-gradient-color3");
          }

          if ($(this).hasClass("sidebar-gradient-color4")) {
            $("body")
              .removeClass(sidebarColors2)

              .addClass("sidebar-gradient-color4");

            localStorage.setItem("navbar-color2", "sidebar-gradient-color4");
          }

          if ($(this).hasClass("sidebar-gradient-color5")) {
            $("body")
              .removeClass(sidebarColors2)

              .addClass("sidebar-gradient-color5");

            localStorage.setItem("navbar-color2", "sidebar-gradient-color5");
          }

          if ($(this).hasClass("sidebar-gradient-color6")) {
            $("body")
              .removeClass(sidebarColors2)

              .addClass("sidebar-gradient-color6");

            localStorage.setItem("navbar-color2", "sidebar-gradient-color6");
          }

          if ($(this).hasClass("sidebar-gradient-color7")) {
            $("body")
              .removeClass(sidebarColors2)

              .addClass("sidebar-gradient-color7");

            localStorage.setItem("navbar-color2", "sidebar-gradient-color7");
          }
        });

        $("#ChagesidebarDefault").on("click", function () {
          $("body").removeClass(sidebarColors2).addClass("theme-default");

          localStorage.setItem("navbar-color2", "theme-default");
        });
      });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/Index.vue